import { KEYS_TAGS } from '@components/imageHandling/common';
import { ChartScopeParams } from '@components/machines/components/eventsChart/types';

export const getChartPropsByScope = ({
  statisticsScope,
  id,
  ncFileId,
  allSelected,
  getMachineStatsPerPeriod,
  getNcFileStatsMonth,
  getNcFileStatsDay,
  getNcFileStatsHour,
}: ChartScopeParams) => ({
  ...{
    [KEYS_TAGS.Machine]: {
      getStats: getMachineStatsPerPeriod,
      id,
      allSelected,
    },
    [KEYS_TAGS.Clamping]: {
      getStatsMonth: getNcFileStatsMonth,
      getStatsDay: getNcFileStatsDay,
      getStatsHour: getNcFileStatsHour,
      getStatsWeek: undefined,
      id: ncFileId,
      allSelected: false,
    },
  }[statisticsScope],
  statisticsScope,
});
